import { useModalStore, withErrorBoundary } from '@navi-app/utils';
import { StyledDivider } from 'baseui/divider';
import { ANCHOR, Drawer, SIZE } from 'baseui/drawer';
import { HeadingXSmall } from 'baseui/typography';
import { useTranslation } from 'react-i18next';
import { useShallow } from 'zustand/react/shallow';
import TutorialCard from './tutorial-card';
import VideoSection from './video-section';

type TMobileViewTutorialVideo = {
  id: string;
  url: string | undefined;
  embedUrl: string | undefined;
  thumbnail: string;
  card: {
    title: string;
    description: string;
  };
  video: {
    title: string;
    description: string;
  };
  videosArr: {
    id: string;
    url: string | undefined;
    embedUrl: string | undefined;
    thumbnail: string;
    card: {
      title: string;
      description: string;
    };
    video: {
      title: string;
      description: string;
    };
  }[];
  onClickCard: (id: string) => void;
};

const MobileViewTutorialVideo = (props: TMobileViewTutorialVideo) => {
  const { t } = useTranslation('modal-tutorial');

  const { modalName, closeModal } = useModalStore(
    useShallow((state) => ({
      modalName: state.modalName,
      closeModal: state.closeModal,
    }))
  );

  return (
    <Drawer
      isOpen={modalName === 'modalTutorialVideo'}
      onClose={closeModal}
      anchor={ANCHOR.bottom}
      size={SIZE.auto}
      overrides={{
        Root: {
          style: {
            zIndex: '999',
          },
        },
        DrawerBody: {
          style: {
            height: '676px',
            overflow: 'hidden',
          },
        },
        DrawerContainer: {
          style: {
            borderRadius: '16px 16px 0 0',
          },
        },
      }}
    >
      <HeadingXSmall>{t('title')}</HeadingXSmall>
      <div className="w-full mt-6">
        <VideoSection {...props} t={t} isPhoneSize={true} />
      </div>
      <StyledDivider className="my-4" />
      <div className="min-h-[200px] max-h-[200px] overflow-y-auto">
        {props.videosArr.map((video) => (
          <TutorialCard
            key={video.id}
            {...video}
            isActive={props.id === video.id}
            onClickCard={props.onClickCard}
          />
        ))}
      </div>
    </Drawer>
  );
};

export default withErrorBoundary(MobileViewTutorialVideo);
